module.exports = __webpack_public_path__ + "static/delaney-06e7cc16658cda759f3d6918d06a5b93.png";